import React, { lazy, Suspense, useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Imports
import TitleText from "./TitleText";
import Filter from "./Filter";
const PackageProductCard = lazy(() => import("./PackageProductCard"));

const LeftArrow = ({ onClick }) => (
	<button
		className='absolute left-[-2rem] top-1/2 transform -translate-y-1/2 z-10'
		onClick={onClick}>
		<img
			src='/assets/left-arrow-icon.svg'
			alt='Previous'
			className='rotate-180 w-6 h-6'
		/>
	</button>
);

const RightArrow = ({ onClick }) => (
	<button
		className='absolute right-[-2rem] top-1/2 transform -translate-y-1/2 z-10'
		onClick={onClick}>
		<img src='/assets/left-arrow-icon.svg' alt='Next' className='w-6 h-6' />
	</button>
);

const PackageProductComponent = ({
	title = "",
	isFilter = true,
	products = [],
}) => {
	const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1024);
	const [selectedFilter, setSelectedFilter] = useState("All");
	const options = [
		"All",
		"Metropolis Healthcare",
		"Redcliffe Labs",
		"Pathkind Labs",
	];

	const filteredProducts = products
		.filter(
			(product) =>
				product.productType === "package" &&
				(selectedFilter === "All" ||
					(product.brandName || "").trim() === selectedFilter)
		)
		.sort((a, b) => {
			const priceA = parseFloat((a.sellingPrice || "0").replace(/,/g, ""));
			const priceB = parseFloat((b.sellingPrice || "0").replace(/,/g, ""));
			return priceA - priceB;
		});
	const slicedProducts = filteredProducts.slice(0, 10);

	// Update screen size state on resize
	useEffect(() => {
		const handleResize = () => setIsLargeScreen(window.innerWidth >= 1024);
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	const settings = isLargeScreen
		? {
				slidesToShow: 2,
				slidesToScroll: 1,
				infinite: true,
				arrows: true,
				autoplay: false,
				dots: true,
				pauseOnHover: true,
				pauseOnFocus: true,
				pauseOnDotsHover: true,
				nextArrow: <RightArrow />,
				prevArrow: <LeftArrow />,
				dotsClass: "slick-dots custom-dots",
				appendDots: (dots) => (
					<div
						style={{
							position: "absolute",
							bottom: "-50px",
							left: "50%",
							transform: "translateX(-50%)",
						}}>
						<ul style={{ margin: "0px" }}>{dots}</ul>
					</div>
				),
				customPaging: (i) => (
					<div
						style={{
							width: "20px",
							height: "8px",
							backgroundColor: "#d1d5db",
							borderRadius: "50px",
						}}></div>
				),
		  }
		: {
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				arrows: false,
				autoplay: false,
				dots: true,
				pauseOnHover: true,
				pauseOnFocus: true,
				pauseOnDotsHover: true,
				//nextArrow: <RightArrow />,
				//prevArrow: <LeftArrow />,
				dotsClass: "slick-dots custom-dots",
				appendDots: (dots) => (
					<div
						style={{
							position: "absolute",
							bottom: "-50px",
							left: "50%",
							transform: "translateX(-50%)",
						}}>
						<ul style={{ margin: "0px" }}>{dots}</ul>
					</div>
				),
				customPaging: (i) => (
					<div
						style={{
							width: "20px",
							height: "8px",
							backgroundColor: "#d1d5db",
							borderRadius: "50px",
						}}></div>
				),
		  };

	return (
		<div className='w-full h-fit bg-white flex flex-col items-center px-[3%] lg:px-0 py-[7.5%] lg:py-[3%] space-y-[3%] lg:space-y-4'>
			{/* Title Section */}
			<div className='w-full lg:w-[80%] flex justify-between items-center lg:pr-6'>
				<TitleText text={title} className=' sm:w-[100px]' />
				<div className='sm:right-10'>
					{isFilter && (
						<Filter
							selected={selectedFilter}
							setSelected={setSelectedFilter}
							options={options}
						/>
					)}
				</div>
			</div>

			{/* Product Slider */}
			<div className='w-full lg:w-[80%] pb-4 hidden lg:block'>
				<Suspense
					fallback={
						<div className='w-full flex justify-center items-center'>
							<span className='font-normal text-[7.5vw] lg:text-[1.25vw] text-textPrimaryColor'>
								Loading package...
							</span>
						</div>
					}>
					<Slider {...settings}>
						{slicedProducts?.map((item, index) => (
							<PackageProductCard data={item} key={index} />
						))}
					</Slider>
				</Suspense>
			</div>

			<div className='w-full lg:w-[80%] pb-4 lg:hidden'>
				<Suspense
					fallback={
						<div className='w-full flex justify-center items-center'>
							<span className='font-normal text-[7.5vw] lg:text-[1.25vw] text-textPrimaryColor'>
								Loading package...
							</span>
						</div>
					}>
					<Slider {...settings}>
						{filteredProducts?.slice(0, 10).map((item, index) => (
							<PackageProductCard data={item} key={index} />
						))}
					</Slider>
				</Suspense>
			</div>
		</div>
	);
};

export default PackageProductComponent;
